// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/_imageslider.scss
// module id = 47
// module chunks = 0